var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-code",style:(_vm.styles)},[_vm._v("\n  "+_vm._s(_vm.code)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }